import formValidation from '../../vendors/FormValidation/core/Core';
import Message from '../../vendors/FormValidation/plugins/Message';
import Trigger from '../../vendors/FormValidation/plugins/Trigger';
import SubmitButton from '../../vendors/FormValidation/plugins/SubmitButton';

import SelectorEngine from './dom/selector-engine';
import ValidationUtils from './validation';

export const VALID_POSTCODE_CHECK = /^(GIR0AA|GIR 0AA|[A-Za-z]{1,2}[0-9][0-9A-Za-z]?\s?[0-9][A-Za-z]{2})$/;
export const GB_ADDRESS_ERROR_MESSAGE = 'Please enter a valid GB address';

const compactPostcode = (postcode) => String(postcode).replace(/[\s\u00A0]+/g, '').toUpperCase();

/**
 * True when the postcode is a valid UK format in Great Britain (excludes Northern Ireland BT*).
 */
export const isGreatBritainPostcode = (postcode) => {
	if (typeof postcode !== 'string') {
		return false;
	}

	const trimmed = postcode.replace(/\u00A0/g, ' ').trim();
	if (!trimmed) {
		return false;
	}

	const compact = compactPostcode(trimmed);
	if (compact.startsWith('BT')) {
		return false;
	}

	return VALID_POSTCODE_CHECK.test(trimmed);
};
// Only letters, digits, and these special characters allowed: !@#$%^&*()_+-=
// Requires at least one upper, one lower, one digit, one special. Length 8–25.
export const PASSWORD_REGEX = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=])[a-zA-Z0-9!@#$%^&*()_+\-=]{8,25}$/;

const attachValidation = (form, fields) => formValidation(
	form,
	{
		fields,
		plugins: {
			trigger: new Trigger(),
			submitButton: new SubmitButton(),
			message: new Message({
				clazz: 'lta-text-input__label-instruction',
				container: function(field, element) {
					let fieldType = element.getAttribute('type');
					if (!fieldType) {
						fieldType = `${element.nodeName.toLowerCase()}`;
					}
					const inputWrapper = element.closest(ValidationUtils.getFieldWrapper(fieldType));
					return SelectorEngine.findOne('.lta-text-input--error', inputWrapper);
				}
			}),
		}
	}
)
	.on('core.field.invalid', (name) => {
		const invalidField = form.querySelector('[name="'+name+'"]');
		let invalidFieldType = invalidField.getAttribute('type');
		if (!invalidFieldType) {
			invalidFieldType = `${invalidField.nodeName.toLowerCase()}`;
		}
		const fieldWrapper = invalidField.closest(ValidationUtils.getFieldWrapper(invalidFieldType));
		fieldWrapper.classList.add(...ValidationUtils.getErrorClasses(invalidFieldType));
	})
	.on('core.field.valid', (name) => {
		const invalidField = form.querySelector('[name="'+name+'"]');
		let invalidFieldType = invalidField.getAttribute('type');
		if (!invalidFieldType) {
			invalidFieldType = `${invalidField.nodeName.toLowerCase()}`;
		}
		const fieldWrapper = invalidField.closest(ValidationUtils.getFieldWrapper(invalidFieldType));
		fieldWrapper.classList.remove(...ValidationUtils.getErrorClasses(invalidFieldType));
	});

export default attachValidation;
